import React, {useEffect, useState} from "react";
import Modal from 'react-modal';
import options from "./options";
import useIsMobile from "./useIsMobile";

export function getModalStyles(isMobile) {
    let styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            zIndex: 1050,
        },
        content: {
            position: 'absolute',
            top: '10%',
            right: 0,
            bottom: 0,
            left: 0,
            border: '1px solid #ccc',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            outline: 'none',
            padding: 0,
            inset: '0 0 10%'
        }
    };

    if (!isMobile) {
        styles.content['top'] = 40;
        styles.content['right'] = 40;
        styles.content['bottom'] = 40;
        styles.content['left'] = 40;
    }

    return styles;
}

export default function CheckoutModal(props) {
    let isMobile = useIsMobile();
    return <Modal style={getModalStyles(isMobile)} {...props}/>;
}